import styled from "styled-components";
import { Callout as BPCallout } from "@blueprintjs/core";

import { AddProjectsButton } from "@pages/overview/components";

const PrimaryCallout = styled(BPCallout)`
  font-size: var(--global-font-size-s);
  display: flex;
  gap: 20px;
  justify-content: space-between;
  align-items: baseline;
  padding: 16px 20px;
`;

export const AddProjectsBanner = () => {
  return (
    <PrimaryCallout intent="primary" icon={null} data-testid="demo-callout">
      <div>
        <b>Curious how it looks with your code?</b>
        &nbsp; Add your repo and see the true power of Semgrep App!
      </div>
      <AddProjectsButton />
    </PrimaryCallout>
  );
};
